import React from 'react';

const COLORS = ['#ff0000', '#00ff00', '#ffd700', '#0066ff', '#ff00ff'];

const ChristmasLights: React.FC = () => {
  // Generate lights for top edge
  const topLights = Array.from({ length: 25 }, (_, i) => ({
    id: `top-${i}`,
    color: COLORS[i % COLORS.length],
    delay: Math.random() * 2,
  }));

  // Generate lights for left edge
  const leftLights = Array.from({ length: 15 }, (_, i) => ({
    id: `left-${i}`,
    color: COLORS[(i + 2) % COLORS.length],
    delay: Math.random() * 2,
  }));

  // Generate lights for right edge
  const rightLights = Array.from({ length: 15 }, (_, i) => ({
    id: `right-${i}`,
    color: COLORS[(i + 4) % COLORS.length],
    delay: Math.random() * 2,
  }));

  return (
    <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
      {/* Top wire and lights */}
      <div className="absolute top-0 left-0 right-0 h-8">
        <div className="absolute top-2 left-0 right-0 h-[2px] bg-gray-800" />
        <div className="flex justify-between px-4">
          {topLights.map((light) => (
            <div
              key={light.id}
              className="relative animate-twinkle"
              style={{ animationDelay: `${light.delay}s` }}
            >
              <div
                className="w-3 h-4 rounded-b-full mt-1"
                style={{
                  backgroundColor: light.color,
                  boxShadow: `0 0 8px 2px ${light.color}`,
                }}
              />
              <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-1 h-2 bg-gray-700 rounded-t" />
            </div>
          ))}
        </div>
      </div>

      {/* Left wire and lights */}
      <div className="absolute top-8 left-0 bottom-0 w-8">
        <div className="absolute left-2 top-0 bottom-0 w-[2px] bg-gray-800" />
        <div className="flex flex-col justify-between h-[70%] py-4">
          {leftLights.map((light) => (
            <div
              key={light.id}
              className="relative animate-twinkle"
              style={{ animationDelay: `${light.delay}s` }}
            >
              <div
                className="w-4 h-3 rounded-r-full ml-1"
                style={{
                  backgroundColor: light.color,
                  boxShadow: `0 0 8px 2px ${light.color}`,
                }}
              />
              <div className="absolute top-1/2 -translate-y-1/2 -left-1 w-2 h-1 bg-gray-700 rounded-l" />
            </div>
          ))}
        </div>
      </div>

      {/* Right wire and lights */}
      <div className="absolute top-8 right-0 bottom-0 w-8">
        <div className="absolute right-2 top-0 bottom-0 w-[2px] bg-gray-800" />
        <div className="flex flex-col justify-between h-[70%] py-4 items-end">
          {rightLights.map((light) => (
            <div
              key={light.id}
              className="relative animate-twinkle"
              style={{ animationDelay: `${light.delay}s` }}
            >
              <div
                className="w-4 h-3 rounded-l-full mr-1"
                style={{
                  backgroundColor: light.color,
                  boxShadow: `0 0 8px 2px ${light.color}`,
                }}
              />
              <div className="absolute top-1/2 -translate-y-1/2 -right-1 w-2 h-1 bg-gray-700 rounded-r" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChristmasLights;
